/* Dear eM v25.3 (Claude, 23/10/2026): giữ trình thiết kế trên MÁY TÍNH (>=750px) như bản v24.9.
   em-tts-fix.js (v26.x, làm cho điện thoại) có vài phần JS chạy cả trên máy tính:
   - tự bấm "thu nhỏ" khi mở trình thiết kế → chặn trên máy tính (giữ mặc định phóng to như cũ)
   - nút "Xem ảnh to / Thu nhỏ" ở bước Xem lại + bấm ảnh để phóng to → ẩn/chặn trên máy tính
   - gợi ý "Phóng to để xem cận cảnh" → ẩn trên máy tính
   v25.5: dòng hướng dẫn dưới hình ("Chạm và kéo để dời chữ / icon…") canh giữa trên máy tính.
   v26.0 (23/10/2026, CEO): máy tính giống điện thoại — mở trình thiết kế là THU NHỎ sẵn (thấy cả sản phẩm)
   và hiện gợi ý "Phóng to để xem cận cảnh" (bấm để phóng to, tự ẩn sau 6 giây). Bỏ chặn tự thu nhỏ + bỏ ẩn gợi ý;
   thêm CSS cho nút gợi ý trên máy tính. Bước Xem lại trên máy tính vẫn giữ như v25.3.
   Điện thoại (<=749px) không đổi. Nạp từ cuối snippets/em-customizer-patch.liquid. */
(function () {
  if (window.__emDeskGate) return; window.__emDeskGate = 1;
  var mq = window.matchMedia('(min-width: 750px)');
  var st = document.createElement('style'); st.id = 'em-desktop-gate';
  st.textContent = '@media screen and (min-width:750px){.tt-cfzoom{display:none!important}' +
    /* v26.0: nút gợi ý phóng to trên máy tính (giống điện thoại) */
    '.dmc-modal .tt-zchip{position:absolute;left:50%;bottom:64px;transform:translateX(-50%);z-index:7;display:inline-flex;align-items:center;gap:6px;height:34px;padding:0 16px;border:0;border-radius:999px;background:rgba(127,99,189,.92);color:#fff;font-family:inherit;font-weight:600;font-size:13px;line-height:1;white-space:nowrap;box-shadow:0 4px 14px rgba(127,99,189,.35);cursor:pointer;animation:emZchipIn .3s ease both}' +
    '.dmc-modal .tt-zchip:hover{background:rgba(127,99,189,1)}' +
    '.dmc-modal .tt-zchip svg{width:16px;height:16px;stroke:currentColor;fill:none;stroke-width:2;stroke-linecap:round}' +
    '.dmc-modal .tt-zchip.is-out{opacity:0;transform:translate(-50%,6px);transition:opacity .3s,transform .3s;pointer-events:none}' +
    '.dmc-modal.is-confirm .tt-zchip{display:none}' +
    /* không chồng với gợi ý zoom sẵn có của trình thiết kế khi nút gợi ý đang hiện */
    '.dmc-stage:has(.tt-zchip:not(.is-out)) .dmc-zoomhint{opacity:0!important;pointer-events:none!important}' +
    '@keyframes emZchipIn{from{opacity:0;transform:translate(-50%,6px)}to{opacity:1;transform:translate(-50%,0)}}' +
    '@media (prefers-reduced-motion:reduce){.dmc-modal .tt-zchip{animation:none}}' +
    /* v25.5: dòng hướng dẫn "Chạm và kéo…" nằm giữa thanh công cụ dưới hình */
    '.dmc-stage__bar .dmc-tip{flex:1 1 auto!important;text-align:center!important}}';
  (document.head || document.documentElement).appendChild(st);
  window.addEventListener('click', function (e) {
    if (!mq.matches || !e.target.closest) return;
    /* v26.0: KHÔNG còn chặn em-tts-fix tự thu nhỏ khi mở (máy tính giống điện thoại) */
    /* bước Xem lại: bấm ảnh không phóng to/thu nhỏ trên máy tính */
    if (e.target.closest('.is-confirm .dmc-canvas, .is-confirm .dmp-canvas') && !e.target.closest('.em-share-fab')) { e.stopImmediatePropagation(); }
  }, true);
  setInterval(function () {
    if (!mq.matches) return;
    var m = document.querySelector('.dmc-modal.tt-cf-big, .dmp-modal.tt-cf-big');
    if (m) m.classList.remove('tt-cf-big');
  }, 400);
})();
